import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as  moment from 'moment';
import { DaytranService } from 'src/providers/daytran-ervice/daytran.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-time-logs',
  templateUrl: './time-logs.component.html',
  styleUrls: ['./time-logs.component.scss']
})
export class TimeLogsComponent {
  logs;
  currentDate: NgbDateStruct = {
    year: Number(moment().format('YYYY')),
    month: Number(moment().format('MM')),
    day: Number(moment().format('DD'))
  };
  type = 1;
  constructor(
    public activeModal: NgbActiveModal,
    private daytranService: DaytranService,
    private spinner: NgxSpinnerService
  ) {
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.spinner.show();
    const dateFilter = this.currentDate.year.toString() + '-' + this.currentDate.month.toString() + '-' + this.currentDate.day.toString();
    this.logs = await this.daytranService.getTimelogs({ date: dateFilter });
    await this.spinner.hide();
  }

  filterChange() {
    this.initialize();
  }

  close() {
    this.activeModal.close();
  }

}
